/**
 * Logo Component
 * StarClinch logo
 * 
 * @author Varun Pandey
 */

import React from 'react';
import { cn } from '../../utils/cn';
import starclinchLogo from '../../assets/images/starclich-logo.png';

export interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Logo: React.FC<LogoProps> = ({ className, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-14 h-14',
    lg: 'w-28 h-28',
  };

  return (
    <div
      className={cn(
        'flex items-center justify-center',
        sizeClasses[size],
        className
      )}
    >
      <img
        src={starclinchLogo}
        alt="StarClinch Logo"
        className="w-full h-full object-contain"
      />
    </div>
  );
};
